import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.32 2.57701C10.094 2.13888 13.906 2.13888 17.68 2.57701C19.177 2.75101 20.25 4.03701 20.25 5.50701V21C20.2498 21.1277 20.217 21.2533 20.1547 21.3648C20.0925 21.4763 20.0027 21.57 19.8941 21.6371C19.7854 21.7042 19.6614 21.7425 19.5338 21.7482C19.4062 21.754 19.2793 21.7271 19.165 21.67L12 18.089L4.835 21.672C4.72058 21.7291 4.59345 21.7561 4.4657 21.7502C4.33795 21.7444 4.21381 21.7059 4.10509 21.6386C3.99637 21.5713 3.90667 21.4772 3.84452 21.3655C3.78237 21.2537 3.74983 21.1279 3.75 21V5.50701C3.75 4.03701 4.823 2.75101 6.32 2.57701Z"
        fill={colorValue}
      />
    </svg>
  );
};
